"use client";

import { useEffect, useState } from "react";
import { fetchAuthSession } from "@aws-amplify/core";
import { signOut } from "aws-amplify/auth";
import { usePathname } from "next/navigation";
import SessionWarningModal from "./SessionWarningModal";

const WARNING_THRESHOLD_MS = 60 * 1000;

export default function SessionManager() {
  const [showWarning, setShowWarning] = useState(false);
  const [expiresAt, setExpiresAt] = useState<number | null>(null);
  const pathname = usePathname();

  
  useEffect(() => {
    const bc = new BroadcastChannel("auth");

    bc.onmessage = async (event) => {
      if (event.data === "logout") {
       await signOut();
        window.location.href = "/login";
      }
    };

    return () => {
      bc.close();
    };
  }, []);


  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = await fetchAuthSession();
        const tokenExp = session.tokens?.accessToken?.payload.exp;

        if (tokenExp) {
          const expMs = tokenExp * 1000;
          setExpiresAt(expMs);
          
        }
      } catch {
        setExpiresAt(null);
      }
    };

    checkSession();
  }, [pathname]);

  useEffect(() => {
    if (!expiresAt) return;

    const now = Date.now();
    const timeUntilWarning = expiresAt - now - WARNING_THRESHOLD_MS;
   
    if (timeUntilWarning <= 0) {
      setShowWarning(true);
    } else {
      const warningTimer = setTimeout(() => setShowWarning(true), timeUntilWarning);
      return () => clearTimeout(warningTimer);
    }
  }, [expiresAt]);

  const broadcastLogout = async () => {
    const bc = new BroadcastChannel("auth");
    bc.postMessage("logout");
    bc.close();

    await signOut();
    window.location.href = "/login";
  };


  const renewSession = async () => {
    try {
      const session = await fetchAuthSession();
      const exp = session.tokens?.accessToken?.payload.exp;

      if (exp) {
        const expMs = exp * 1000;
        setExpiresAt(expMs);
       
      }
    } catch (err) {
      console.error("Session renew failed:", err);
      broadcastLogout();
    }
    setShowWarning(false);
  };

  const handleExpire = async () => {   
    broadcastLogout();
  };

  return showWarning ? (
    <SessionWarningModal onExtend={renewSession} onExpire={handleExpire} />
  ) : null;
}
